import LeagueMapper from './league-mapper';

const LeagueModel = {
    mapper: LeagueMapper,

    categoryId: {
        type: String,
    },

    categoryName: {
        type: String,
    },

    countryCode: {
        type: String,
    },

    eventCount: {
        type: Number,
    },

    id: {
        type: String,
    },

    names: {
        type: Object,
    },

    order: {
        type: Number,
    },
};

export default LeagueModel;
